import { useState } from 'react'

import { Edit02Icon, SquareLock01Icon } from '@hugeicons/react'
import { toast } from 'sonner'

import { useResourceRecordContext } from '@/shared/hooks'
import { api } from '@/shared/lib/api'
import { Button, Card } from '@/shared/ui'
import { alert } from '@/shared/ui/dialog'
import { InputGroup } from '@/shared/ui/Form'
import { Label } from '@/components/ui/label'
import { Input } from '@/components/ui/input'

import { BottomSheetWrapper } from '../BottomSheetWrapper'
import { DigitalProductMyProfilePassword } from '../Fields/Password'

export const SecurityPanel = () => {
  const { Form, isSubmitting } = useResourceRecordContext()
  const [openEditPassword, setOpenEditPassword] = useState(false)

  const handleUpdatePassword = data => {
    api
      .put(`/user/update_password`, {
        record: {
          password: data?.password,
          password_confirmation: data?.password_confirmation,
          current_password: data?.current_password
        }
      })
      .then(() => {
        toast.success('Senha alterada com sucesso')
      })
      .catch(error => {
        console.error(error)

        void alert({
          variant: 'destructive',
          title: 'Erro ao alterar senha',
          description:
            error?.response?.data?.message || 'Tente novamente mais tarde.',
          confirmLabel: 'Fechar'
        })
      })
  }

  return (
    <>
      <Card>
        <Card.Body className="p-4 sm:p-5">
          <div className="flex w-full flex-col">
            <Label className="mb-2 block">Senha</Label>
            <InputGroup>
              <InputGroup.Addon tone="brand">
                <SquareLock01Icon variant="stroke" size={18} />
              </InputGroup.Addon>
              <Input
                type="password"
                className="rounded-none border-0 bg-transparent focus-visible:ring-0"
                value="********"
                disabled
                readOnly
              />
              <InputGroup.Addon
                interactive
                onClick={() => setOpenEditPassword(true)}
                aria-label="Editar senha"
              >
                <Edit02Icon variant="stroke" size={18} />
              </InputGroup.Addon>
            </InputGroup>
          </div>
        </Card.Body>
      </Card>

      <BottomSheetWrapper
        open={openEditPassword}
        onClose={() => setOpenEditPassword(false)}
        title="Alterar senha"
      >
        <Form
          validationSchema={DigitalProductMyProfilePassword.validationSchema}
          onSubmit={handleUpdatePassword}
          onSave={() => setOpenEditPassword(false)}
        >
          <DigitalProductMyProfilePassword />
          <div className="mt-4 flex gap-2">
            <Button
              type="submit"
              variant="primary"
              size="sm"
              loading={isSubmitting}
              showTrailingIcon={false}
            >
              Atualizar senha
            </Button>
            <Button
              type="button"
              variant="secondary"
              size="sm"
              onClick={() => setOpenEditPassword(false)}
            >
              Cancelar
            </Button>
          </div>
        </Form>
      </BottomSheetWrapper>
    </>
  )
}
